export default __webpack_public_path__ + "static/media/completed_receivable.688e88fd.png";